import run from '../../utilities/run';
import $ from 'jquery';
import _ from "underscore";
import {setElementsFromScope} from "./../../utilities/selectorHelpers";

const targetSelector = "#product-by-inventory-dashboard";

run(targetSelector, (mainEl) => {
  attachOrgForm(mainEl);
});

function attachOrgForm(mainEl) {
    const facilityData = mainEl.data("facility-data");
    const viewUrl=mainEl.data("facility-url"); 
    const inventoryLookupUrl=mainEl.data("inventory-lookup-url");

      const els = {};
      const elementsMap = {
        addFacilitySelect : '#facility-select',
      }

      function init() {
        setElements();
        bindElements();
        renderFacilityList();
      } 

      function setElements() {
        setElementsFromScope(els, elementsMap, mainEl);
      }

      function bindElements(){        
        els.addFacilitySelect.on('change', facilityChangeRequest); 
      }

      function renderFacilityList(){
        $(facilityData).each(function(){
          var option=$('<option />');
          option.attr('value', this.facCode).text(this.facName);
          els.addFacilitySelect.append(option);
        });
      }

        function facilityChangeRequest(){
            
            let facCode = els.addFacilitySelect.val();
            if(facCode=="All Facilities"){
             facCode="All";
            }
            let newviewUrl=`${viewUrl}&facCode=${facCode}`;
            $.ajax({
               url: newviewUrl,
               type: 'POST',
               dataType: "JSON",
               data:  {
                facCode:facCode
               },
               success:function(response) {
                 $('#outOfStockProducts').html(response.outStockCount);
                 $('#lowStockProducts').html(response.lowStockCount);
                 $('#inStockProducts').html(response.inStockCount);
                 $('#outofstockLink').attr('href',inventoryLookupUrl+"&filterFlag=outofstock&facCode="+facCode);
                $('#lowstockLink').attr('href',inventoryLookupUrl+"&filterFlag=lowstock&facCode="+facCode);
                $('#instockLink').attr('href',inventoryLookupUrl+"&filterFlag=instock&facCode="+facCode);
               },
               error: function(response){
                   console.log("error"+JSON.stringify(response));
               }
             }); 
            }

    init();
} 


// WEBPACK FOOTER //
// ./src/pages/dashboard/product-by-inventory.js